import React from 'react';
export default function PositionLevelField({ levels, error, value, onChange, style, labelStyle }) {
  const missing = value && !levels.some(level => String(level.id) === String(value));
  return <>
    <label htmlFor="position-level" style={labelStyle}>Position Level (optional)</label>
    <select id="position-level" style={style} value={value || ''} onChange={event => onChange(event.target.value)}>
      <option value="">No level</option>
      {missing && <option value={value} disabled>Current level unavailable — select another or No level</option>}
      {levels.map(level => <option key={level.id} value={level.id}>{level.name}</option>)}
    </select>
    {error ? <small style={{ display: 'block', marginTop: 6, color: '#b91c1c', fontSize: '0.75rem', lineHeight: 1.4 }} role="alert">Could not load position levels. Close and reopen the page to retry, or choose No level.</small>
      : !levels.length && <small style={{ display: 'block', marginTop: 6, color: '#64748b', fontSize: '0.75rem', lineHeight: 1.4 }}>No position levels have been created for this company. You can save without one. Add levels under Position Ranks &amp; Levels.</small>}
  </>;
}
